import { Routes } from '@angular/router';

export const APPLICATIONS_ROUTES: Routes = [
  { path: 'applications', loadComponent: () => import('./pages/apps-list/apps-list.component').then((m) => m.AppsListComponent) },
  { path: 'applications/new', loadComponent: () => import('./pages/create-app/create-app.component').then((m) => m.CreateAppComponent) },
  { path: 'applications/:id', loadComponent: () => import('./pages/app-detail/app-detail.component').then((m) => m.AppDetailComponent) },
  { path: 'scopes', loadComponent: () => import('./pages/scopes/scopes.component').then((m) => m.ScopesComponent) },
  { path: 'connected-apps', loadComponent: () => import('./pages/connected-apps/connected-apps.component').then((m) => m.ConnectedAppsComponent) },
  { path: 'review', loadComponent: () => import('./pages/review/review.component').then((m) => m.ReviewComponent) },
];
